import React, { useContext, useState } from 'react';
import RegularButton from 'components/CustomButtons/Button';
import Typography from '@material-ui/core/Typography';
import { UserContext } from 'contexts/userContext';
import { TextField } from '@material-ui/core';
import { wsUpdate } from 'services/WService';
import Modal from '@material-ui/core/Modal';
import Box from '@material-ui/core/Box';

const REQUISITOS_PASSWORD = 'Mínimo 6 caracteres, una mayúscula y un número';

const passwordValida = (password) =>
  password.length >= 6 && /[A-Z]/.test(password) && /[0-9]/.test(password);

function ChangePasswordDialog() {
  const { user, setUser } = useContext(UserContext);
  const [processing, setProcessing] = useState(false);
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [repeatNewPassword, setRepeatNewPassword] = useState('');

  async function savePassword() {
    setProcessing(true);
    let res = await wsUpdate('oauth/user/current', {
      password,
      newPassword,
    });
    setProcessing(false);
    if (res.success) {
      alert('Contraseña actualizada');
      setUser({ ...user, reset_password: !user.reset_password });
    } else {
      alert(`Error: ${res.message}`);
    }
  }

  return (
    <Modal open={true} onClose={() => {}}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" component="h2">
          Cambio de contraseña
        </Typography>
        <Typography sx={{ mt: 2 }}>Cambie su contraseña para continuar</Typography>
        <Typography sx={{ mt: 1, fontSize: 12, color: '#666' }}>{REQUISITOS_PASSWORD}</Typography>

        <TextField
          fullWidth
          label="Contraseña"
          type="password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <TextField
          fullWidth
          label="Nueva Contraseña"
          type="password"
          autoComplete="new-password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <TextField
          fullWidth
          label="Repita nueva Contraseña"
          type="password"
          autoComplete="new-password"
          value={repeatNewPassword}
          onChange={(e) => setRepeatNewPassword(e.target.value)}
        />

        <RegularButton
          color="success"
          onClick={savePassword}
          disabled={
            processing ||
            password.length === 0 ||
            !passwordValida(newPassword) ||
            newPassword !== repeatNewPassword
          }
        >
          Guardar
        </RegularButton>
      </Box>
    </Modal>
  );
}

export default ChangePasswordDialog;
